import React, { useEffect, useState } from 'react';
import styled, { withTheme } from 'styled-components';
import { Switch, Route, NavLink, Link as NormalLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Avatar from 'react-avatar';
import * as Cookies from 'js-cookie';
import * as userActions from '../../store/actions';
import {
    parseAutomaticLogin,
} from '../functions';
import config from '../../config';
import i18n from '../../i18n';

import { Logo } from '../../common';
import { User, Menu } from '../Icons';

const Wrapper = styled.header`
    box-shadow: 0px 2px 7px rgba(0,0,0,0.5);
    position: relative;
    z-index: 1;
`;

const Appbar = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 80px;
    padding: 0.5em 36px;
    background-color: ${(props) => props.theme.background};

    @media (max-width: 700px) {
        padding: 0.5em;
    }
`;

const RightContainer = styled.div`
    display: flex;
    align-items: center;
    height: 100%;
    flex-shrink: 0;
    justify-content: flex-end;

    @media (max-width: ${(props) => props.theme.headerMobileLimit}) {
        display: none;
    }
`;

const UserIconStyled = styled(User)`
    fill: ${(props) => props.theme.userIcon};
    height: 80%;
`;

const Button = styled.div`
    background-color: ${(props) => props.theme.headerButtonBackground};
    padding: 10px 30px 10px 30px;
    font-weight: bold;
    border: 0px;
    border-radius: 10px;
    cursor: pointer;
    color: ${(props) => props.theme.headerButtonText};
    text-transform: uppercase;
    margin-right: 10px;
`;

const Login = styled(Button)`
`;

const Logout = styled(Button)`
`;

const Register = styled(Button)`
`;

const Return = styled(Button)`
    background: #EAEDFA;
    border:  3px solid ${(props) => props.theme.primary};
    color: ${(props) => props.theme.primary};
`;

const Navigation = styled.nav`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50px;
    background: ${(props) => props.theme.background};
    @media (max-width: ${(props) => props.theme.headerMobileLimit}) {
        display: none;
    }
`;

const Link = styled(NavLink)`
    text-decoration: none;
    letter-spacing: 0em;
    white-space: nowrap;
    color: ${(props) => props.theme.text};
    margin: 0 2em;
    font-family: "Titillium Web";
    font-weight: 500;
    font-size: 14pt;
    border-bottom: 5px transparent solid;
    &.active {
        text-decoration: underline;
    }
`;

const ExternalLink = styled.a`
    text-decoration: none;
    letter-spacing: 0em;
    white-space: nowrap;
    color: ${(props) => props.theme.text};
    margin: 0 2em;
    font-family: "Titillium Web";
    font-weight: 500;
    font-size: 14pt;
    cursor: pointer;
    border-bottom: 5px transparent solid;
    &.active {
        text-decoration: underline;
    }
`;

const BackToLink = styled(ExternalLink)`
    margin: 0 auto;
`;

const MobileMenuIcon = styled(Menu)`
    margin-left: 1em;
    cursor: pointer;
    fill: ${(props) => props.theme.primary};
    position: absolute;
    right: 2em;

    @media (min-width: ${(props) => props.theme.headerMobileLimit}) {
        display: none;
    }
`;

const LogoLink = styled(NormalLink)`
    position: absolute;
    top: 2em

    @media (max-width: ${(props) => props.theme.headerMobileLimit}) {
        height: 100%;
    }
`;

const Header = ({
    history,
    location,
    user: { authenticated, first_name, last_name, cart },
    userActions: { login, logout, refreshAccounts, register, openMenu },
    ...props
}) => {
    useEffect(() => {
        if(!authenticated && parseAutomaticLogin(location)) {
            login();
        }
    }, [location]);

    return (
        <Wrapper>
            <Appbar {...props}>
                <LogoLink to='/'>
                    <Logo />
                </LogoLink>

                <Switch>
                    <Route component={() => (
                        <Navigation>
                            {!config.nuorelleSiivetOnly &&
                             <Link exact to='/'>
                                 Etusivu
                             </Link>
                            }
                            {config.playableTicketsEnabled &&
                             <Link to='/pelattavat'>
                                 Pelaa arpoja
                             </Link>

                            }
                            {
                                config.nuorelleSiivetOnly ?
                                    <Link to={`/lunastettavat/${config.nuorelleSiivetSlug}`}>Arpojen rekisteröinti</Link> :
                                    <Link to='/lunastettavat'>
                                        {config.playableTicketsEnabled && 'Muut arvat' || 'Arvat'}
                                    </Link>
                            }

                            <Link
                                to='/voittokauppa'
                                onClick={() => authenticated && refreshAccounts()}
                            >
                                Voittokauppa
                            </Link>

                            {authenticated && (
                                <Link
                                    to='/tili'
                                    onClick={() => authenticated && refreshAccounts()}
                                >
                                    Oma tili
                                </Link>
                            )}
                        </Navigation>
                    )} />
                </Switch>
                <RightContainer>
                    {config.nuorelleSiivetOnly && (
                        <Return
                            onClick={() => window.location.href = 'https://nuorellesiivet.fi'}
                        >
                            Takaisin nuorellesiivet.fi
                        </Return>
                    )}
                    {authenticated ? (
                        <>
                            <Logout onClick={() => logout()}>
                                {i18n.gettext('logout')}
                            </Logout>
                            <Avatar
                                color={props.theme.avatar}
                                name={first_name + ' ' + last_name}
                                round={true}
                                size='40px'
                                style={{ fontWeight: 'bold' }}
                            />
                        </>
                    ) : (
                        <>
                            <Register onClick={() => register()}>
                                Uusi tili
                            </Register>
                            <Login onClick={() => login()}>
                                {i18n.gettext('login')}
                            </Login>
                            <UserIconStyled />
                        </>
                    )}
                </RightContainer>
                <MobileMenuIcon onClick={() => openMenu()}/>
            </Appbar>
        </Wrapper>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        userActions: bindActionCreators({ ...userActions }, dispatch)
    };
};

const ConnectedHeader = withTheme(withRouter(connect(mapStateToProps, mapDispatchToProps)(Header)));

export { ConnectedHeader as Header };
